import { API_BASE_URL } from "../assets/const";
import { checkAndUpdateToken } from "./auth";
import { SET_ROOM_TYPES, SET_ROOM_TYPES_LOAD } from "./types";
import { buildDefaultHeaders } from "./helper";
import { createNotification } from "../components/Notifications/Notifications";

export const getRoomTypesList = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: SET_ROOM_TYPES_LOAD, payload: true });
    const response = await fetch(`${API_BASE_URL}/room_types`, {
      method: "GET",
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_ROOM_TYPES, payload: data});
    }
  }
  dispatch({ type: SET_ROOM_TYPES_LOAD, payload: false });
};

export const editRoomType = (data) => async (dispatch, getState) => {
    let success;
    try {
      await dispatch(checkAndUpdateToken());
      if (getState().auth.token) {
        dispatch({ type: SET_ROOM_TYPES_LOAD, payload: true });
        const response = await fetch(`${API_BASE_URL}/room_types/${data.rtid}`, {
          method: "PUT",
          ...buildDefaultHeaders(getState),
          body: JSON.stringify(data)
        });
        if (response.ok) {
          success = true;
          createNotification('success', 'Изменения сохранены');
          dispatch(getRoomTypesList())
        } else {
          createNotification('error', 'Не удалось сохранить запись');
        }
      }
    } catch (ERR) {
      createNotification('error', 'Не удалось сохранить запись');
    } finally {
      dispatch({ type: SET_ROOM_TYPES_LOAD, payload: false });
    }
    return success;
  };

  export const addRoomType = (data) => async (dispatch, getState) => {
    let success;
    try {
      await dispatch(checkAndUpdateToken());
      if (getState().auth.token) {
        dispatch({ type: SET_ROOM_TYPES_LOAD, payload: true });
        const response = await fetch(`${API_BASE_URL}/room_types`, {
          method: "POST",
          ...buildDefaultHeaders(getState),
          body: JSON.stringify(data)
        });
        if (response.ok) {
          success = true;
          createNotification('success', 'Тип кабинета добавлен');
          dispatch(getRoomTypesList());
        } else {
          createNotification('error', 'Не удалось создать запись');
        }
      }
    } catch (ERR) {
      createNotification('error', 'Не удалось создать запись');
    } finally {
      dispatch({ type: SET_ROOM_TYPES_LOAD, payload: false });
    }
    return success;
  };

  export const deleteRoomType = (id) => async (dispatch, getState) => {
    await dispatch(checkAndUpdateToken());
    if (getState().auth.token) {
      dispatch({ type: SET_ROOM_TYPES_LOAD, payload: true });
      const response = await fetch(`${API_BASE_URL}/room_types/${id}`, {
        method: "DELETE",
        ...buildDefaultHeaders(getState),
      });
      if (response.ok) {
        createNotification('success', 'Успешно');
        dispatch(getRoomTypesList());
      }
    }
    dispatch({ type: SET_ROOM_TYPES_LOAD, payload: false });
  };
